import React, { useEffect, useMemo, useState } from "react";
import "../../../Assets/CSS/bulkorder.css";
import "../oms.css";
import Up from "../../../Assets/Images/OMS/up.svg";
import Down from "../../../Assets/Images/OMS/down.svg";
import Transport from "../../../Assets/Images/OMS_New/transport (1).svg";
import CloseIcon from "@material-ui/icons/Close";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import ImageIcon from "@mui/icons-material/Image";
import { useFormik } from "formik";
import DeleteIcon from "@mui/icons-material/Delete";
import { Box, Button } from "@mui/material";
import axios from "axios";
import { ClipLoader } from "react-spinners";
import toast from "react-hot-toast";
import moment from "moment";
import IconButton from "@material-ui/core/IconButton";
import ShowPDF from "../common/pdfViewer";
import { Modal } from "@material-ui/core";
import Switch from "@mui/material/Switch";

function TransportDetailSupplierForm({
  orderId,
  orderShipmentDocs,
  getOMSData,
  omsData,
}) {
  const isPending =
    omsData?.only_bnps?.ayekart_lvl1_status !== "Approved" ||
    omsData?.only_bnps?.ayekart_lvl2_status !== "Approved";

  const [supplierTransportDetails, setSupplierTransportDetails] =
    useState(false);

  const [uploading, setUploading] = useState(false);
  const [transportDetails, setTransportDetails] = useState({});
  const [pdfUrl, setPdfUrl] = useState("");
  const [activeModal, setActiveModal] = useState(false);
  const [rcSelectedFile, setRcSelectedFile] = useState([]);
  const [selectedTransportGstPan, setSelectedTransporterGstPan] = useState([]);
  const [selectedTruckLoadingImage, setSelectedTruckLoadingImage] = useState(
    []
  );
  const [selectedDriverPhoto, setSelectedDriverPhoto] = useState([]);
  const [selectedDriverLicense, setSelectedDriverLicense] = useState([]);
  const [selectedTdsDeclaration, setSelectedTdsDeclaration] = useState([]);
  const [selectedRevisedBilti, setSelectedRevisedBilti] = useState([]);
  const [selectedKantaParchi, setSelectedKantaParchi] = useState([]);
  const [selectedRetailerPaidCheque, setSelectedRetalierPaidCheque] = useState(
    []
  );
  const [selectedEway, setSelectedEway] = useState([]);
  const [selectedInsurenceDoc, setSelectedInsurenceDoc] = useState([]);

  const [docState, setDocState] = useState({
    kanta_parchi_oms: [],
    revised_bilti_oms: [],
    tds_declaration_oms: [],
    driver_license_oms: [],
    driver_photo_oms: [],
    rc_oms: [],
    transporter_gst_pan_oms: [],
    retailer_paid_cheque_oms: [],
    grn_document_oms: [],
    truck_loading_image_oms: [],
    eway_oms: [],
    truck_insurance_docs: [],
  });

  const selectOptions = [
    { label: "Yes", value: "yes" },
    { label: "No", value: "no" },
  ];

  const initialValues = {
    is_transport_of_supplier: null,
    bilti_issued_date: null,
    advance_amount: null,
    truck_number: null,
    truck_chasis_number: null,
    truck_driver_contact_no: null,
    driver_name: null,
    truck_haulted_start_date: null,
    truck_haulted_charges: null,
    truck_haulted_charges_paid: null,
    is_gps_tracker_given: null,
    has_truck_reached_destination: null,
    truck_number_2: null,
    truck_chasis_number_2: null,
    truck_driver_contact_no_2: null,
    transporter_gst_pan: null,
    rc: null,
    truck_loading_image: null,
    driver_photo: null,
    driver_license: null,
    mandi_tax: null,
    tds_declaration: null,
    revised_bilti: null,
    kanta_parchi: null,
    retailer_paid_cheque: null,
    driver_name_2: null,
    truck_haulted_end_date: null,
    grn_document: null,
    is_truck_halted: false,
    is_truck_breakdown: false,
    eway: null,
    total_transport_cost: null,
    lr_number: null,
    transporter_name: null,
    transportion_rate_in_qtl: null,
    transporter_deduction_charges: null,
    final_payments_transporter: null,
    transporter_balance_amount: null,
    truck_insured: false,
    truck_insurance_number: "",
    truck_insurance_provider: "",
    truck_insurance_bared_by: "",
    truck_insurance_cost: null,
    truck2_insured: false,
    truck2_insurance_number: "",
    truck2_insurance_provider: "",
    truck2_insurance_bared_by: "",
    truck2_insurance_cost: null,
    goods_insured: false,
    goods_insurance_number: "",
  };

  const validate = (values) => {
    const errors = {};
    if (!values.driver_name) {
      errors.driver_name = "Driver Name is Required";
    }
    if (!values.truck_number) {
      errors.truck_number = "Truck Number is Required";
    }

    if (!values.truck_number_2 && values.is_truck_breakdown === "yes") {
      errors.truck_number_2 = "Truck Number is Required";
    }
    if (!values.driver_name_2 && values.is_truck_breakdown === "yes") {
      errors.driver_name_2 = "Driver Name is Required";
    }

    if (
      values.truck_driver_contact_no &&
      !/^\d{10}$/.test(values.truck_driver_contact_no)
    ) {
      errors.truck_driver_contact_no = "Phone number should be 10 digits.";
    }
    if (
      values.truck_driver_contact_no_2 &&
      !/^\d{10}$/.test(values.truck_driver_contact_no_2)
    ) {
      errors.truck_driver_contact_no_2 = "Phone number should be 10 digits.";
    }

    if (!values.bilti_issued_date) {
      errors.bilti_issued_date = "Bilti issued Date is required";
    }

    if (values.goods_insured && !values.goods_insurance_number) {
      errors.goods_insurance_number = "Goods insurance number required";
    }

    if (values.truck_insured) {
      if (!values.truck_insurance_number) {
        errors.truck_insurance_number = "Truck insurance number required";
      }
      if (!values.truck_insurance_provider) {
        errors.truck_insurance_provider = "Truck insurance provider required";
      }
      if (!values.truck_insurance_bared_by) {
        errors.truck_insurance_bared_by = "Truck insurance bared by required";
      }
      if (!values.truck_insurance_cost) {
        errors.truck_insurance_cost = "Truck insurance cost required";
      }
    }

    if (values.truck2_insured && values.is_truck_breakdown === "yes") {
      if (!values.truck2_insurance_number) {
        errors.truck2_insurance_number = "Truck insurance number required";
      }
      if (!values.truck2_insurance_provider) {
        errors.truck2_insurance_provider = "Truck insurance provider required";
      }
      if (!values.truck2_insurance_bared_by) {
        errors.truck2_insurance_bared_by = "Truck insurance bared by required";
      }
      if (!values.truck2_insurance_cost) {
        errors.truck2_insurance_cost = "Truck insurance cost required";
      }
    }

    if (!values.truck_haulted_start_date && values.is_truck_halted === "yes") {
      errors.truck_haulted_start_date = "Start Date is Required";
    }
    if (!values.truck_haulted_end_date && values.is_truck_halted === "yes") {
      errors.truck_haulted_end_date = "End date is required";
    }
    return errors;
  };

  const handleModalClose = () => {
    setPdfUrl("");
    setActiveModal(false);
  };

  const handleModalOpen = (pdfUrl) => {
    setPdfUrl(pdfUrl);
    setActiveModal(true);
  };

  const handleSubmit = async (values) => {
    const payload = {
      order_id: orderId,
      bilti_issued_date: values.bilti_issued_date || null,
      advance_amount: values.advance_amount || null,
      truck_details: values.truck_number || null,
      truck_chasis_number: values.truck_chasis_number || null,
      truck_driver_mobile: values.truck_driver_contact_no || null,
      is_transport_of_supplier:
        values.is_transport_of_supplier === "yes"
          ? true
          : values.is_transport_of_supplier === "no"
          ? false
          : null,
      truck_driver_name: values.driver_name || null,
      truck_halt_start_time: values.truck_haulted_start_date || null,
      truck_halt_end_time: values.truck_haulted_end_date || null,
      truck_halt_charges: values.truck_haulted_charges || null,
      is_truck_halted_charges_paid:
        values.truck_haulted_charges_paid === "yes"
          ? true
          : values.truck_haulted_charges_paid === "no"
          ? false
          : null,
      is_gps_provided:
        values.is_gps_tracker_given === "yes"
          ? true
          : values.is_gps_tracker_giver === "no"
          ? false
          : null,
      truck_reached_destination:
        values.has_truck_reached_destination === "yes"
          ? true
          : values.has_truck_reached_destination === "no"
          ? false
          : null,

      total_transport_cost: values?.total_transport_cost || null,
      truck_number_2: values.truck_number_2 || null,
      truck_chasis_number_2: values.truck_chasis_number_2 || null,
      truck_driver_contact_no_2: values.truck_driver_contact_no_2 || null,
      transporter_gst_pan_oms: docState.transporter_gst_pan_oms,
      rc_oms: docState.rc_oms,
      truck_loading_image_oms: docState.truck_loading_image_oms,
      driver_photo_oms: docState.driver_photo_oms,
      driver_license_oms: docState.driver_license_oms,
      mandi_tax_url: values.mandi_tax || null,
      tds_declaration_oms: docState.tds_declaration_oms,
      revised_bilti_oms: docState.revised_bilti_oms,
      kanta_parchi_oms: docState.kanta_parchi_oms,
      retailer_paid_cheque_oms: docState.retailer_paid_cheque_oms,
      driver_name_2: values.driver_name_2 || null,
      grn_document_oms: docState.grn_document_oms,
      merchant_type: "supplier",
      is_oms: true,
      is_truck_halted:
        values.is_truck_halted === "yes"
          ? true
          : values.is_truck_halted === "no"
          ? false
          : null,
      is_truck_breakdown:
        values.is_truck_breakdown === "yes"
          ? true
          : values.is_truck_breakdown === "no"
          ? false
          : null,

      eway_oms: docState.eway_oms,
      truck_insurance_docs: docState?.truck_insurance_docs,
      lr_number: values?.lr_number,
      transporter_name: values?.transporter_name,
      transportion_rate_in_qtl: values?.transportion_rate_in_qtl,
      transporter_deduction_charges: values?.transporter_deduction_charges,
      final_payments_transporter: values?.final_payments_transporter,
      transporter_balance_amount: values?.transporter_balance_amount,
      truck_insured: values?.truck_insured,
      truck_insurance_number: values?.truck_insurance_number,
      truck_insurance_provider: values?.truck_insurance_provider,
      truck_insurance_bared_by: values?.truck_insurance_bared_by,
      truck_insurance_cost: values?.truck_insurance_cost,
      truck2_insured: values?.truck2_insured,
      truck2_insurance_number: values?.truck2_insurance_number,
      truck2_insurance_provider: values?.truck2_insurance_provider,
      truck2_insurance_bared_by: values?.truck2_insurance_bared_by,
      truck2_insurance_cost: values?.truck2_insurance_cost,
      goods_insured: values?.goods_insured,
      goods_insurance_number: values?.goods_insurance_number,
    };

    try {
      const { data } = await axios.post("/api/oms/shipment/docs", payload);
      if (data.status) {
        formik.resetForm();
        getOMSData();
        toast.success(data.message);
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(
        error.response ? error.response.data.message : "An error occured"
      );
    }
  };

  const setInvoice = (fileLocation, event) => {
    switch (event.target.name) {
      case "eway":
        setDocState((prev) => ({
          ...prev,
          eway_oms: [...prev.eway_oms, fileLocation],
        }));

        break;
      case "kanta_parchi":
        setDocState((prev) => ({
          ...prev,
          kanta_parchi_oms: [...prev.kanta_parchi_oms, fileLocation],
        }));

        break;
      case "revised_bilti":
        setDocState((prev) => ({
          ...prev,
          revised_bilti_oms: [...prev.revised_bilti_oms, fileLocation],
        }));

        break;
      case "tds_declaration":
        setDocState((prev) => ({
          ...prev,
          tds_declaration_oms: [...prev.tds_declaration_oms, fileLocation],
        }));

        break;
      case "driver_license":
        setDocState((prev) => ({
          ...prev,
          driver_license_oms: [...prev.driver_license_oms, fileLocation],
        }));

        break;
      case "driver_photo":
        setDocState((prev) => ({
          ...prev,
          driver_photo_oms: [...prev.driver_photo_oms, fileLocation],
        }));

        break;
      case "rc":
        setDocState((prev) => ({
          ...prev,
          rc_oms: [...prev.rc_oms, fileLocation],
        }));

        break;
      case "transporter_gst_pan":
        setDocState((prev) => ({
          ...prev,
          transporter_gst_pan_oms: [
            ...prev.transporter_gst_pan_oms,
            fileLocation,
          ],
        }));

        break;
      case "retailer_paid_cheque":
        setDocState((prev) => ({
          ...prev,
          retailer_paid_cheque_oms: [
            ...prev.retailer_paid_cheque_oms,
            fileLocation,
          ],
        }));

        break;
      case "grn_document":
        setDocState((prev) => ({
          ...prev,
          grn_document_oms: [...prev.grn_document_oms, fileLocation],
        }));

        break;
      case "truck_loading_image":
        setDocState((prev) => ({
          ...prev,
          truck_loading_image_oms: [
            ...prev.truck_loading_image_oms,
            fileLocation,
          ],
        }));

        break;
      case "truck_insurance_docs":
        setDocState((prev) => ({
          ...prev,
          truck_insurance_docs: [...prev.truck_insurance_docs, fileLocation],
        }));

        break;
    }
  };

  const onFileChange = async (event, setUrl) => {
    switch (event.target.name) {
      case "eway":
        setDocState((prev) => ({
          ...prev,
          eway_oms: transportDetails?.eway_oms || [],
        }));

        break;
      case "kanta_parchi":
        setDocState((prev) => ({
          ...prev,
          kanta_parchi_oms: transportDetails?.kanta_parchi_oms || [],
        }));

        break;
      case "revised_bilti":
        setDocState((prev) => ({
          ...prev,
          revised_bilti_oms: transportDetails?.revised_bilti_oms || [],
        }));

        break;
      case "tds_declaration":
        setDocState((prev) => ({
          ...prev,
          tds_declaration_oms: transportDetails?.tds_declaration_oms || [],
        }));

        break;
      case "driver_license":
        setDocState((prev) => ({
          ...prev,
          driver_licence_oms: transportDetails?.driver_licence_oms || [],
        }));

        break;
      case "driver_photo":
        setDocState((prev) => ({
          ...prev,
          driver_photo_oms: transportDetails?.driver_photo_oms || [],
        }));

        break;
      case "rc":
        setDocState((prev) => ({
          ...prev,
          rc_oms: transportDetails?.rc_oms || [],
        }));

        break;
      case "transporter_gst_pan":
        setDocState((prev) => ({
          ...prev,
          transporter_gst_pan_oms:
            transportDetails?.transporter_gst_pan_oms || [],
        }));

        break;
      case "retailer_paid_cheque":
        setDocState((prev) => ({
          ...prev,
          retailer_paid_cheque_oms:
            transportDetails?.retailer_paid_cheque_oms || [],
        }));

        break;
      case "grn_document":
        setDocState((prev) => ({
          ...prev,
          grn_document_oms: transportDetails?.grn_document_oms || [],
        }));

        break;
      case "truck_loading_image":
        setDocState((prev) => ({
          ...prev,
          truck_loading_image_oms:
            transportDetails?.truck_loading_image_oms || [],
        }));

        break;
      case "truck_insurance_docs":
        setDocState((prev) => ({
          ...prev,
          truck_insurance_docs: transportDetails?.truck_insurance_docs || [],
        }));

        break;
    }
    const files = event.target.files;

    if (files.length > 0) {
      setUploading(true);

      const uploadPromises = Array.from(files).map(async (file) => {
        const formData = new FormData();
        formData.append("file", file);

        try {
          const uploadResponse = await fetch(
            "/upload/mitra-merchant/doc-upload",
            {
              method: "POST",
              body: formData,
            }
          );

          if (uploadResponse.ok) {
            const uploadResponseData = await uploadResponse.json();
            setUrl(uploadResponseData.file_location, event);
          } else {
            throw new Error("Failed to upload file.");
          }
        } catch (error) {
          setUploading(false);
          console.error("Error uploading file:", error);
        }
      });

      try {
        await Promise.all(uploadPromises);
        setUploading(false);
      } catch (error) {
        setUploading(false);
        console.error("Error uploading files:", error);
      }
    }
  };

  const handleDeleteDriverPhoto = (index) => {
    const newState = [...docState.driver_photo_oms];
    newState.splice(index, 1);
    setDocState((prevState) => ({
      ...prevState,
      driver_photo_oms: newState,
    }));
  };
  const handleDeleteTransporterGst = (index) => {
    const newState = [...docState.transporter_gst_pan_oms];
    newState.splice(index, 1);
    setDocState((prevState) => ({
      ...prevState,
      transporter_gst_pan_oms: newState,
    }));
  };
  const handleDeleteRc = (index) => {
    const newState = [...docState.rc_oms];
    newState.splice(index, 1);
    setDocState((prevState) => ({
      ...prevState,
      rc_oms: newState,
    }));
  };
  const handleDeleteTruckLoading = (index) => {
    const newState = [...docState.truck_loading_image_oms];
    newState.splice(index, 1);
    setDocState((prevState) => ({
      ...prevState,
      truck_loading_image_oms: newState,
    }));
  };
  const handleDeleteDriverLicense = (index) => {
    const newState = [...docState.driver_license_oms];
    newState.splice(index, 1);
    setDocState((prevState) => ({
      ...prevState,
      driver_license_oms: newState,
    }));
  };
  const handleDeleteTdsDeclaration = (index) => {
    const newState = [...docState.tds_declaration_oms];
    newState.splice(index, 1);
    setDocState((prevState) => ({
      ...prevState,
      tds_declaration_oms: newState,
    }));
  };
  const handleDeleteRevisedBilti = (index) => {
    const newState = [...docState.revised_bilti_oms];
    newState.splice(index, 1);
    setDocState((prevState) => ({
      ...prevState,
      revised_bilti_oms: newState,
    }));
  };
  const handleDeleteKantaParchi = (index) => {
    const newState = [...docState.kanta_parchi_oms];
    newState.splice(index, 1);
    setDocState((prevState) => ({
      ...prevState,
      kanta_parchi_oms: newState,
    }));
  };
  const handleDeleteRetailerCheque = (index) => {
    const newState = [...docState.retailer_paid_cheque_oms];
    newState.splice(index, 1);
    setDocState((prevState) => ({
      ...prevState,
      retailer_paid_cheque_oms: newState,
    }));
  };
  const handleDeleteGrnDocument = (index) => {
    const newState = [...docState.grn_document_oms];
    newState.splice(index, 1);
    setDocState((prevState) => ({
      ...prevState,
      grn_document_oms: newState,
    }));
  };

  const handleDeleteEwayBill = (index) => {
    const newState = [...docState.eway_oms];
    newState.splice(index, 1);
    setDocState((prevState) => ({
      ...prevState,
      eway_oms: newState,
    }));
  };

  const handleDeleteTrackInsurence = (index) => {
    const newState = [...docState.truck_insurance_docs];
    newState.splice(index, 1);
    setDocState((prevState) => ({
      ...prevState,
      truck_insurance_docs: newState,
    }));
  };

  const formik = useFormik({
    initialValues: initialValues,
    validate,
    onSubmit: handleSubmit,
  });

  useEffect(() => {
    const transport = orderShipmentDocs?.find(
      (obj) => obj.merchant_type === "supplier"
    );

    if (transport) {
      setTransportDetails(transport);
      setDocState((prev) => ({
        ...prev,
        eway_oms: transport?.eway_oms || [],
        kanta_parchi_oms: transport?.kanta_parchi_oms || [],
        revised_bilti_oms: transport?.revised_bilti_oms || [],
        tds_declaration_oms: transport?.tds_declaration_oms || [],
        driver_license_oms: transport?.driver_license_oms || [],
        driver_photo_oms: transport?.driver_photo_oms || [],
        rc_oms: transport?.rc_oms || [],
        transporter_gst_pan_oms: transport?.transporter_gst_pan_oms || [],
        retailer_paid_cheque_oms: transport?.retailer_paid_cheque_oms || [],
        grn_document_oms: transport?.grn_document_oms || [],
        truck_loading_image_oms: transport?.truck_loading_image_oms || [],
        truck_insurance_docs: transport?.truck_insurance_docs || [],
      }));
      formik.setValues({
        ...formik.values,
        has_truck_reached_destination:
          transport?.truck_reached_destination === true
            ? "yes"
            : transport?.truck_reached_destination === false
            ? "no"
            : null,
        is_gps_tracker_given:
          transport?.is_gps_provided === true
            ? "yes"
            : transport?.is_gps_provided === false
            ? "no"
            : null,
        truck_haulted_charges: transport?.truck_halt_charges || null,
        truck_haulted_charges_paid:
          transport?.is_truck_halted_charges_paid === true
            ? "yes"
            : transport?.is_truck_halted_charges_paid === false
            ? "no"
            : null,
        driver_name: transport?.truck_driver_name || "",
        truck_driver_contact_no: transport?.truck_driver_mobile || "",
        advance_amount: transport?.advance_amount || "",
        truck_number: transport?.truck_details || "",
        truck_chasis_number: transport?.truck_chasis_number || "",
        bilti_issued_date: transport?.bilti_issued_date
          ? moment(transport?.bilti_issued_date).format("YYYY-MM-DD")
          : null,
        is_transport_of_supplier:
          transport?.is_transport_of_supplier === true
            ? "yes"
            : transport?.is_transport_of_supplier === false
            ? "no"
            : null,
        total_transport_cost: transport?.total_transport_cost || null,
        date_of_truck_arrival: transport?.date_of_truck_arrival
          ? moment(transport?.date_of_truck_arrival).format("YYYY-MM-DD")
          : null,

        unloading_weight_bag: transport?.unloading_weight_bag || null,
        truck_haulted_start_date: transport?.truck_halt_start_time
          ? moment(transport?.truck_halt_start_time).format("YYYY-MM-DD")
          : null,
        truck_haulted_end_date: transport?.truck_halt_end_time
          ? moment(transport?.truck_halt_end_time).format("YYYY-MM-DD")
          : null,
        truck_number_2: transport?.truck_number_2 || "",
        truck_chasis_number_2: transport?.truck_chasis_number_2 || "",
        truck_driver_contact_no_2: transport?.truck_driver_contact_no_2 || "",
        driver_name_2: transport?.driver_name_2 || null,
        is_truck_halted:
          transport?.is_truck_halted === true
            ? "yes"
            : transport?.is_truck_halted === false
            ? "no"
            : null,
        is_truck_breakdown:
          transport?.is_truck_breakdown === true
            ? "yes"
            : transport?.is_truck_breakdown === false
            ? "no"
            : null,

        lr_number: transport?.lr_number ? transport?.lr_number : null,
        transporter_name: transport?.transporter_name
          ? transport?.transporter_name
          : null,
        transportion_rate_in_qtl: transport?.transportion_rate_in_qtl
          ? transport?.transportion_rate_in_qtl
          : null,
        transporter_deduction_charges: transport?.transporter_deduction_charges
          ? transport?.transporter_deduction_charges
          : "",
        final_payments_transporter: transport?.final_payments_transporter
          ? transport?.final_payments_transporter
          : null,
        transporter_balance_amount: transport?.transporter_balance_amount
          ? transport?.transporter_balance_amount
          : null,

        goods_insured: transport?.goods_insured
          ? transport?.goods_insured
          : false,
        goods_insurance_number: transport?.goods_insurance_number
          ? transport?.goods_insurance_number
          : "",
        truck_insured: transport?.truck_insured
          ? transport?.truck_insured
          : false,
        truck_insurance_number: transport?.truck_insurance_number
          ? transport?.truck_insurance_number
          : "",
        truck_insurance_provider: transport?.truck_insurance_provider
          ? transport?.truck_insurance_provider
          : "",
        truck_insurance_bared_by: transport?.truck_insurance_bared_by
          ? transport?.truck_insurance_bared_by
          : "",
        truck_insurance_cost: transport?.truck_insurance_cost
          ? transport?.truck_insurance_cost
          : null,
        truck2_insured: transport?.truck2_insured
          ? transport?.truck2_insured
          : false,
        truck2_insurance_number: transport?.truck2_insurance_number
          ? transport?.truck2_insurance_number
          : "",
        truck2_insurance_provider: transport?.truck2_insurance_provider
          ? transport?.truck2_insurance_provider
          : "",
        truck2_insurance_bared_by: transport?.truck2_insurance_bared_by
          ? transport?.truck2_insurance_bared_by
          : "",
        truck2_insurance_cost: transport?.truck2_insurance_cost
          ? transport?.truck2_insurance_cost
          : null,
      });
    }
  }, [orderShipmentDocs, formik.setValues]);

  const isTruckNumberGiven = useMemo(() => {
    const transport = orderShipmentDocs?.find(
      (obj) => obj.merchant_type === "supplier"
    );
    return transport?.truck_details !== null && transport?.truck_details !== '';
  }, [orderShipmentDocs]);

  const getChasisNumber = async (truckNumberField, chasisNumberField) => {
    const truckNumber = formik.values[truckNumberField];
    if (!truckNumber) {
      return;
    }
    try {
      const response = await axios({
        url: "/common/common_apis/vehicle_verification",
        method: "post",
        data: {
          id_number: truckNumber,
        },
      });
      if (
        response?.data?.status &&
        response?.data?.data?.data?.vehicle_chasi_number
      ) {
        formik.setFieldValue(
          chasisNumberField,
          response.data.data.data.vehicle_chasi_number
        );
      } else {
        toast.error(
          "Error while fetching the chasis number of given truck number."
        );
      }
    } catch {
      console.log("Error while fetching chasis information");
      toast.error(
        "Error while fetching the chasis number of given truck number."
      );
    }
  };

  return (
    <>
      <Modal
        open={activeModal}
        onClose={handleModalClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            width: "50%",
            height: "80%",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            overflowY: "auto",
          }}
        >
          <div className="">
            <IconButton
              aria-label="close"
              style={{ position: "absolute", right: "8px", top: "8px" }}
              onClick={handleModalClose}
            >
              <CloseIcon />
            </IconButton>
          </div>
          <div className="flex flex-col items-center justify-center space-y-5 h-full">
            {pdfUrl?.toLowerCase().endsWith(".pdf") ? (
              <ShowPDF pdfUrl={pdfUrl} />
            ) : (
              <img src={pdfUrl} alt="uploaded image" />
            )}
          </div>
        </Box>
      </Modal>

      <div className="shadow-lg m-2 p-2 pb-2 rounded-lg">
        <div className="flex flex-col sm:flex-row justify-between">
          <div className="font-medium text-cyan-950 text-md flex gap-1">
            <img src={Transport} alt="" />
            <div className="ms-1"> Transport Details</div>
          </div>
          <div>
            {supplierTransportDetails ? (
              <div className="font-medium text-cyan-950 text-lg mt-2">
                <img
                  src={Up}
                  alt=""
                  role="button"
                  onClick={() =>
                    setSupplierTransportDetails(!supplierTransportDetails)
                  }
                />
              </div>
            ) : (
              <div className="font-medium text-cyan-950 text-lg mt-2">
                <img
                  src={Down}
                  alt=""
                  role="button"
                  onClick={() =>
                    setSupplierTransportDetails(!supplierTransportDetails)
                  }
                />
              </div>
            )}
          </div>
        </div>
        <div>
          <hr className="font-bold text-neutral-500 bg-gray-900 h-0.5" />
        </div>
        <div>
          {supplierTransportDetails ? (
            <></>
          ) : (
            <div>
              <form onSubmit={formik.handleSubmit}>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2">
                  <div className="mb-3">
                    <label className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1">
                      Is Transport Of Supplier?
                    </label>
                    <select
                      value={formik.values.is_transport_of_supplier}
                      onChange={formik.handleChange}
                      name="is_transport_of_supplier"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      disabled={isPending}
                    >
                      <option value="Select Expense">Select Option</option>
                      {selectOptions.map((each, index) => (
                        <option value={each.value} key={index}>
                          {each.label}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label
                      for="truck_number"
                      className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                    >
                      Truck Number
                    </label>
                    <input
                      type="text"
                      id="truck_number"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="truck_number"
                      placeholder="Enter Truck Number"
                      value={formik.values.truck_number}
                      onChange={formik.handleChange}
                      onBlur={() =>
                        getChasisNumber("truck_number", "truck_chasis_number")
                      }
                      disabled={isPending || isTruckNumberGiven}
                    />
                    {formik.errors.truck_number ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.errors.truck_number}
                      </div>
                    ) : null}
                  </div>
                  <div>
                    <label
                      for="truck_chasis_number"
                      className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                    >
                      Truck Chasis Number
                    </label>
                    <input
                      type="text"
                      id="truck_chasis_number"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="truck_chasis_number"
                      placeholder="Truck Chasis Number"
                      value={formik.values.truck_chasis_number}
                      disabled
                    />
                  </div>
                  <div>
                    <label
                      for="advance_amount"
                      className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                    >
                      Advance Amount (Rs)
                    </label>
                    <input
                      type="number" onWheel={(e) => e.target.blur()}
                      id="advance_amount"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="advance_amount"
                      placeholder="Enter Advance Amount"
                      value={formik.values.advance_amount}
                      onChange={formik.handleChange}
                      disabled={isPending}
                    />
                  </div>
                  <div>
                    <label
                      for="truck_driver_contact_no"
                      className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                    >
                      Truck Driver Contact Number
                    </label>
                    <input
                      type="text"
                      id="truck_driver_contact_no"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="truck_driver_contact_no"
                      placeholder="Enter Driver Number"
                      value={formik.values.truck_driver_contact_no}
                      onChange={formik.handleChange}
                      disabled={isPending}
                    />
                  </div>
                  <div>
                    <label
                      for="driver_name"
                      className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                    >
                      Driver Name
                    </label>
                    <input
                      type="text"
                      id="driver_name"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="driver_name"
                      placeholder="Enter Driver Name"
                      value={formik.values.driver_name}
                      onChange={formik.handleChange}
                      disabled={isPending}
                    />
                    {formik.errors.driver_name ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.errors.driver_name}
                      </div>
                    ) : null}
                  </div>
                  <div>
                    <label
                      for="bilti_issued_date"
                      className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                    >
                      Date if Bilti Issued
                    </label>
                    <input
                      type="date"
                      id="bilti_issued_date"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="bilti_issued_date"
                      placeholder="Enter Driver Name"
                      value={formik.values.bilti_issued_date}
                      onChange={formik.handleChange}
                      disabled={isPending}
                    />
                    {formik.errors.bilti_issued_date ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.errors.bilti_issued_date}
                      </div>
                    ) : null}
                  </div>
                  <div className="mb-3">
                    <label className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1">
                      Is Truck Halted ?
                    </label>
                    <select
                      value={formik.values.is_truck_halted}
                      onChange={(e) => {
                        formik.handleChange(e);
                      }}
                      name="is_truck_halted"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      disabled={isPending}
                    >
                      <option value="Select Expense">Select Option</option>
                      {selectOptions.map((each, index) => (
                        <option value={each.value} key={index}>
                          {each.label}
                        </option>
                      ))}
                    </select>
                    {formik.errors.is_truck_halted ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.errors.is_truck_halted}
                      </div>
                    ) : null}
                  </div>
                  {formik.values.is_truck_halted === "yes" ? (
                    <>
                      <div>
                        <label
                          for="truck_haulted_start_date"
                          className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                        >
                          Truck Halted Start Date
                        </label>
                        <input
                          type="date"
                          id="truck_haulted_start_date"
                          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                          name="truck_haulted_start_date"
                          placeholder="Enter Driver Name"
                          value={formik.values.truck_haulted_start_date}
                          onChange={formik.handleChange}
                          disabled={isPending}
                        />
                        {formik.errors.truck_haulted_start_date ? (
                          <div className="text-red-600 text-sm flex justify-start ms-1">
                            {formik.errors.truck_haulted_start_date}
                          </div>
                        ) : null}
                      </div>
                      <div>
                        <label
                          for="truck_haulted_end_date"
                          className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                        >
                          Truck Halted End Date
                        </label>
                        <input
                          type="date"
                          id="truck_haulted_end_date"
                          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                          name="truck_haulted_end_date"
                          placeholder="Enter Driver Name"
                          value={formik.values.truck_haulted_end_date}
                          onChange={formik.handleChange}
                          disabled={isPending}
                        />
                        {formik.errors.truck_haulted_end_date ? (
                          <div className="text-red-600 text-sm flex justify-start ms-1">
                            {formik.errors.truck_haulted_end_date}
                          </div>
                        ) : null}
                      </div>
                      <div>
                        <label
                          for="truck_haulted_charges"
                          className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                        >
                          Truck Halted Charges (Rs)
                        </label>
                        <input
                          type="number" onWheel={(e) => e.target.blur()}
                          id="truck_haulted_charges"
                          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                          name="truck_haulted_charges"
                          placeholder="Enter Charge"
                          value={formik.values.truck_haulted_charges}
                          onChange={formik.handleChange}
                          disabled={isPending}
                        />
                        {formik.errors.truck_haulted_charges ? (
                          <div className="text-red-600 text-sm flex justify-start ms-1">
                            {formik.errors.truck_haulted_charges}
                          </div>
                        ) : null}
                      </div>
                      <div className="mb-3">
                        <label className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1">
                          Is Truck Halted charges paid?
                        </label>
                        <select
                          value={formik.values.truck_haulted_charges_paid}
                          onChange={formik.handleChange}
                          name="truck_haulted_charges_paid"
                          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                          disabled={isPending}
                        >
                          <option value="Select Expense">Select Option</option>
                          {selectOptions.map((each, index) => (
                            <option value={each.value} key={index}>
                              {each.label}
                            </option>
                          ))}
                        </select>
                        {formik.errors.truck_haulted_charges_paid ? (
                          <div className="text-red-600 text-sm flex justify-start ms-1">
                            {formik.errors.truck_haulted_charges_paid}
                          </div>
                        ) : null}
                      </div>
                    </>
                  ) : (
                    <></>
                  )}
                  <div className="mb-3">
                    <label className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1">
                      Is GPS Tracker given?
                    </label>
                    <select
                      value={formik.values.is_gps_tracker_given}
                      onChange={formik.handleChange}
                      name="is_gps_tracker_given"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      disabled={isPending}
                    >
                      <option value="Select Expense">Select Option</option>
                      {selectOptions.map((each, index) => (
                        <option value={each.value} key={index}>
                          {each.label}
                        </option>
                      ))}
                    </select>
                    {formik.errors.is_gps_tracker_given ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.errors.is_gps_tracker_given}
                      </div>
                    ) : null}
                  </div>
                  <div className="mb-3">
                    <label className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1">
                      Is Truck BreakDown?
                    </label>
                    <select
                      value={formik.values.is_truck_breakdown}
                      onChange={(e) => {
                        formik.handleChange(e);
                        if (e.currentTarget.value === "no") {
                          formik.setFieldValue("truck2_insured", false);
                          formik.setFieldValue("truck2_insurance_number", "");
                          formik.setFieldValue("truck2_insurance_provider", "");
                          formik.setFieldValue("truck2_insurance_bared_by", "");
                          formik.setFieldValue("truck2_insurance_cost", null);
                        }
                      }}
                      name="is_truck_breakdown"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      disabled={isPending}
                    >
                      <option value="Select Expense">Select Option</option>
                      {selectOptions.map((each, index) => (
                        <option value={each.value} key={index}>
                          {each.label}
                        </option>
                      ))}
                    </select>
                    {formik.errors.is_truck_breakdown ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.errors.is_truck_breakdown}
                      </div>
                    ) : null}
                  </div>
                  {formik.values.is_truck_breakdown === "yes" && (
                    <>
                      <div>
                        <label
                          for="truck_number_2"
                          className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                        >
                          Truck Number 2
                        </label>
                        <input
                          type="text"
                          id="truck_number_2"
                          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                          name="truck_number_2"
                          placeholder="Enter Driver Name"
                          value={formik.values.truck_number_2}
                          onChange={formik.handleChange}
                          onBlur={() =>
                            getChasisNumber(
                              "truck_number_2",
                              "truck_chasis_number_2"
                            )
                          }
                          disabled={isPending}
                        />
                        {formik.errors.truck_number_2 ? (
                          <div className="text-red-600 text-sm flex justify-start ms-1">
                            {formik.errors.truck_number_2}
                          </div>
                        ) : null}
                      </div>
                      <div>
                        <label
                          for="truck_chasis_number_2"
                          className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                        >
                          Truck Chasis Number 2
                        </label>
                        <input
                          type="text"
                          id="truck_chasis_number_2"
                          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                          name="truck_chasis_number_2"
                          placeholder="Truck Chasis Number 2"
                          value={formik.values.truck_chasis_number_2}
                          disabled
                        />
                      </div>
                      <div>
                        <label
                          for="truck_driver_contact_no_2"
                          className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                        >
                          Truck Driver Contact No 2
                        </label>
                        <input
                          type="text"
                          id="truck_driver_contact_no_2"
                          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                          name="truck_driver_contact_no_2"
                          placeholder="Enter Driver Name"
                          value={formik.values.truck_driver_contact_no_2}
                          onChange={formik.handleChange}
                          disabled={isPending}
                        />
                        {formik.errors.truck_driver_contact_no_2 ? (
                          <div className="text-red-600 text-sm flex justify-start ms-1">
                            {formik.errors.truck_driver_contact_no_2}
                          </div>
                        ) : null}
                      </div>
                      <div>
                        <label
                          for="driver_name_2"
                          className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                        >
                          Driver Name 2
                        </label>
                        <input
                          type="text"
                          id="driver_name_2"
                          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                          name="driver_name_2"
                          placeholder="Enter Driver Name"
                          value={formik.values.driver_name_2}
                          onChange={formik.handleChange}
                          disabled={isPending}
                        />
                        {formik.errors.driver_name_2 ? (
                          <div className="text-red-600 text-sm flex justify-start ms-1">
                            {formik.errors.driver_name_2}
                          </div>
                        ) : null}
                      </div>
                    </>
                  )}
                  <div>
                    <label className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1">
                      Total Transport Cost
                    </label>
                    <input
                      type="text"
                      id="total_transport_cost"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="total_transport_cost"
                      placeholder="Enter Total Transport Cost"
                      value={formik.values.total_transport_cost}
                      onChange={formik.handleChange}
                      disabled={isPending}
                    />
                    {formik.errors.total_transport_cost ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.errors.total_transport_cost}
                      </div>
                    ) : null}
                  </div>
                  <div>
                    <label className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1">
                      Has Truck Reached Destination?
                    </label>
                    <select
                      value={formik.values.has_truck_reached_destination}
                      onChange={(e) => {
                        formik.handleChange(e);
                      }}
                      name="has_truck_reached_destination"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      disabled={isPending}
                    >
                      <option value="Select Expense">Select Option</option>
                      {selectOptions.map((each, index) => (
                        <option value={each.value} key={index}>
                          {each.label}
                        </option>
                      ))}
                    </select>
                    {formik.errors.has_truck_reached_destination ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.errors.has_truck_reached_destination}
                      </div>
                    ) : null}
                  </div>
                  {/* new Fields */}
                  <div>
                    <label className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1">
                      Transporter Name
                    </label>
                    <input
                      type="text"
                      id="transporter_name"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="transporter_name"
                      placeholder="Enter Transporter Name"
                      value={formik.values?.transporter_name}
                      onChange={formik.handleChange}
                      disabled={isPending}
                    />
                    {formik.errors.transporter_name ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.errors.transporter_name}
                      </div>
                    ) : null}
                  </div>
                  <div>
                    <label className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1">
                      LR Number
                    </label>
                    <input
                      type="text"
                      id="lr_number"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="lr_number"
                      placeholder="Enter LR Number"
                      value={formik.values?.lr_number}
                      onChange={formik.handleChange}
                      disabled={isPending}
                    />
                    {formik.errors.lr_number ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.errors.lr_number}
                      </div>
                    ) : null}
                  </div>
                  <div>
                    <label className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1">
                      Transportion Rate In Qtl
                    </label>
                    <input
                      type="number" onWheel={(e) => e.target.blur()}
                      id="transportion_rate_in_qtl"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="transportion_rate_in_qtl"
                      placeholder="Enter Transportion Rate In Qtl"
                      value={formik.values?.transportion_rate_in_qtl}
                      onChange={formik.handleChange}
                      disabled={isPending}
                    />
                    {formik.errors.transportion_rate_in_qtl ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.errors.transportion_rate_in_qtl}
                      </div>
                    ) : null}
                  </div>
                  <div>
                    <label className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1">
                      Transporter Deduction Charges
                    </label>
                    <input
                      type="number" onWheel={(e) => e.target.blur()}
                      id="transporter_deduction_charges"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="transporter_deduction_charges"
                      placeholder="Enter Transporter Deduction Charges"
                      value={formik.values?.transporter_deduction_charges}
                      onChange={formik.handleChange}
                      disabled={isPending}
                    />
                    {formik.errors.transporter_deduction_charges ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.errors.transporter_deduction_charges}
                      </div>
                    ) : null}
                  </div>
                  <div>
                    <label className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1">
                      Final Payments Transporter
                    </label>
                    <input
                      type="number" onWheel={(e) => e.target.blur()}
                      id="final_payments_transporter"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="final_payments_transporter"
                      placeholder="Enter Final Payments Transporter"
                      value={formik.values?.final_payments_transporter}
                      onChange={formik.handleChange}
                      disabled={isPending}
                    />
                    {formik.errors.final_payments_transporter ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.errors.final_payments_transporter}
                      </div>
                    ) : null}
                  </div>
                  <div>
                    <label className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1">
                      Transporter Balance Amount
                    </label>
                    <input
                      type="number" onWheel={(e) => e.target.blur()}
                      id="transporter_balance_amount"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="transporter_balance_amount"
                      placeholder="Enter Transporter Balance Amount"
                      value={formik.values?.transporter_balance_amount}
                      onChange={formik.handleChange}
                      disabled={isPending}
                    />
                    {formik.errors.transporter_balance_amount ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.errors.transporter_balance_amount}
                      </div>
                    ) : null}
                  </div>
                  <div>
                    <label className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1">
                      Truck insured ?
                    </label>
                    <div className="flex justify-between">
                      <Switch
                        checked={formik.values?.truck_insured}
                        onChange={(evt) => {
                          formik.setFieldValue(
                            "truck_insured",
                            evt.currentTarget.checked
                          );
                        }}
                        inputProps={{
                          "aria-label": "controlled",
                          name: "truck_insured",
                        }}
                      />
                      {formik.values?.truck_insured && (
                        <>
                          <input
                            type="number" onWheel={(e) => e.target.blur()}
                            id="truck_insurance_number"
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            name="truck_insurance_number"
                            placeholder="Enter Truck Insurance Number"
                            value={formik.values?.truck_insurance_number}
                            onChange={formik.handleChange}
                            disabled={isPending}
                          />
                          {formik.errors.truck_insurance_number ? (
                            <div className="text-red-600 text-sm flex justify-start ms-1">
                              {formik.errors.truck_insurance_number}
                            </div>
                          ) : null}
                        </>
                      )}
                    </div>
                  </div>
                  {formik.values?.truck_insured && (
                    <>
                      <div>
                        <label className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1">
                          Truck insurance provider
                        </label>
                        <input
                          type="text"
                          id="truck_insurance_provider"
                          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                          name="truck_insurance_provider"
                          placeholder="Enter Truck Insurance Provider"
                          value={formik.values?.truck_insurance_provider}
                          onChange={formik.handleChange}
                          disabled={isPending}
                        />
                        {formik.errors.truck_insurance_provider ? (
                          <div className="text-red-600 text-sm flex justify-start ms-1">
                            {formik.errors.truck_insurance_provider}
                          </div>
                        ) : null}
                      </div>
                      <div>
                        <label className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1">
                          Truck insurance bared by
                        </label>
                        <input
                          type="text"
                          id="truck_insurance_bared_by"
                          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                          name="truck_insurance_bared_by"
                          placeholder="Enter Truck Insurance Bared By"
                          value={formik.values?.truck_insurance_bared_by}
                          onChange={formik.handleChange}
                          disabled={isPending}
                        />
                        {formik.errors.truck_insurance_bared_by ? (
                          <div className="text-red-600 text-sm flex justify-start ms-1">
                            {formik.errors.truck_insurance_bared_by}
                          </div>
                        ) : null}
                      </div>
                      <div>
                        <label className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1">
                          Truck insurance cost
                        </label>
                        <input
                          type="number" onWheel={(e) => e.target.blur()}
                          id="truck_insurance_cost"
                          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                          name="truck_insurance_cost"
                          placeholder="Enter Truck Insurance Cost"
                          value={formik.values?.truck_insurance_cost}
                          onChange={formik.handleChange}
                          disabled={isPending}
                        />
                        {formik.errors.truck_insurance_cost ? (
                          <div className="text-red-600 text-sm flex justify-start ms-1">
                            {formik.errors.truck_insurance_cost}
                          </div>
                        ) : null}
                      </div>
                    </>
                  )}
                  {formik.values.is_truck_breakdown === "yes" && (
                    <div>
                      <label className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1">
                        Truck2 insured ?
                      </label>
                      <div className="flex justify-between">
                        <Switch
                          checked={formik.values?.truck2_insured}
                          onChange={(evt) => {
                            formik.setFieldValue(
                              "truck2_insured",
                              evt.currentTarget.checked
                            );
                          }}
                          inputProps={{
                            "aria-label": "controlled",
                            name: "truck2_insured",
                          }}
                        />
                        {formik.values?.truck2_insured && (
                          <>
                            <input
                              type="number" onWheel={(e) => e.target.blur()}
                              id="truck2_insurance_number"
                              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                              name="truck2_insurance_number"
                              placeholder="Enter Truck Insurance Number"
                              value={formik.values?.truck2_insurance_number}
                              onChange={formik.handleChange}
                              disabled={isPending}
                            />
                            {formik.errors.truck2_insurance_number ? (
                              <div className="text-red-600 text-sm flex justify-start ms-1">
                                {formik.errors.truck2_insurance_number}
                              </div>
                            ) : null}
                          </>
                        )}
                      </div>
                    </div>
                  )}
                  {formik.values?.truck2_insured && (
                    <>
                      <div>
                        <label className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1">
                          Truck2 insurance provider
                        </label>
                        <input
                          type="text"
                          id="truck2_insurance_provider"
                          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                          name="truck2_insurance_provider"
                          placeholder="Enter Truck Insurance Provider"
                          value={formik.values?.truck2_insurance_provider}
                          onChange={formik.handleChange}
                          disabled={isPending}
                        />
                        {formik.errors.truck2_insurance_provider ? (
                          <div className="text-red-600 text-sm flex justify-start ms-1">
                            {formik.errors.truck2_insurance_provider}
                          </div>
                        ) : null}
                      </div>
                      <div>
                        <label className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1">
                          Truck2 insurance bared by
                        </label>
                        <input
                          type="text"
                          id="truck2_insurance_bared_by"
                          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                          name="truck2_insurance_bared_by"
                          placeholder="Enter Truck Insurance Bared By"
                          value={formik.values?.truck2_insurance_bared_by}
                          onChange={formik.handleChange}
                          disabled={isPending}
                        />
                        {formik.errors.truck2_insurance_bared_by ? (
                          <div className="text-red-600 text-sm flex justify-start ms-1">
                            {formik.errors.truck2_insurance_bared_by}
                          </div>
                        ) : null}
                      </div>
                      <div>
                        <label className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1">
                          Truck2 insurance cost
                        </label>
                        <input
                          type="number" onWheel={(e) => e.target.blur()}
                          id="truck2_insurance_cost"
                          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                          name="truck2_insurance_cost"
                          placeholder="Enter Truck Insurance Cost"
                          value={formik.values?.truck2_insurance_cost}
                          onChange={formik.handleChange}
                          disabled={isPending}
                        />
                        {formik.errors.truck2_insurance_cost ? (
                          <div className="text-red-600 text-sm flex justify-start ms-1">
                            {formik.errors.truck2_insurance_cost}
                          </div>
                        ) : null}
                      </div>
                    </>
                  )}
                  <div>
                    <label className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1">
                      Goods insured ?
                    </label>
                    <div className="flex justify-between">
                      <Switch
                        className="float-left"
                        checked={formik.values?.goods_insured}
                        disabled={isPending}
                        onChange={(evt) => {
                          formik.setFieldValue(
                            "goods_insured",
                            evt.currentTarget.checked
                          );
                        }}
                        inputProps={{
                          "aria-label": "controlled",
                          name: "goods_insured",
                        }}
                      />
                      {formik.values?.goods_insured && (
                        <input
                          type="number" onWheel={(e) => e.target.blur()}
                          id="goods_insurance_number"
                          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-5/6 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                          name="goods_insurance_number"
                          placeholder="Enter Goods Insurance Number"
                          value={formik.values?.goods_insurance_number}
                          onChange={formik.handleChange}
                          disabled={isPending}
                        />
                      )}

                      {formik.values?.goods_insured &&
                      formik.errors.goods_insurance_number &&
                      formik.touched.goods_insurance_number ? (
                        <div className="text-red-600 text-sm flex justify-start ms-1">
                          {formik.errors.goods_insurance_number}
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
                {/* <div className="font-medium text-cyan-950 text-md flex gap-1">
                  <img src={Transport} alt="" />
                  <div className="ms-1"> Truck(s) Details</div>
                </div>
                <TruckDetails formik={formik} isPending={isPending} /> */}
                <div className="mt-4 mb-2 text-center ">
                  <h1 className="text-2xl">Documents</h1>
                </div>
                <div className="grid grid-cols-4 gap-2">
                  <div className="">
                    <div className="border-2 rounded p-2 bg-gray-300">
                      <div className="text-xl mb-3">
                        <span> Transporter GST/PAN</span>
                      </div>
                      {docState.transporter_gst_pan_oms.length === 0 ? (
                        <div>
                          <div>
                            <i
                              class="fa fa-file-pdf-o fs-1 text-secondary"
                              aria-hidden="true"
                            ></i>
                          </div>
                          <span className="p-1 bg-red-200 rounded mb-2">
                            <span style={{ color: "#fc3503" }}>
                              Not Uploaded
                            </span>
                          </span>
                        </div>
                      ) : (
                        docState.transporter_gst_pan_oms.map((each, index) => (
                          <div key={index} className="border-2">
                            <div className="cursor-pointer flex justify-between">
                              <div></div>
                              <div
                                onClick={() =>
                                  handleDeleteTransporterGst(index)
                                }
                              >
                                <DeleteIcon />
                              </div>
                            </div>
                            {(each?.toLowerCase().endsWith(".jpg") ||
                              each?.toLowerCase().endsWith(".png") ||
                              each?.toLowerCase().endsWith(".jpeg")) && (
                              <div>
                                <ImageIcon style={{ fontSize: "60px" }} />
                              </div>
                            )}
                            {each?.toLowerCase().endsWith(".pdf") && (
                              <div>
                                <FileCopyIcon style={{ fontSize: "60px" }} />
                              </div>
                            )}
                            <div className="p-2">
                              <div>
                                <button
                                  className="bg-blue-500 text-white rounded p-2 mr-2"
                                  onClick={() => handleModalOpen(each)}
                                  type="button"
                                >
                                  View
                                </button>
                                <button
                                  className="bg-blue-500 text-white rounded p-2"
                                  type="button"
                                >
                                  <a
                                    style={{
                                      textDecoration: "none",
                                      color: "inherit",
                                    }}
                                    href={each}
                                  >
                                    Download
                                  </a>
                                </button>
                              </div>
                            </div>
                          </div>
                        ))
                      )}
                      <input
                        id="file"
                        type="file"
                        name="transporter_gst_pan"
                        onChange={(e) => {
                          onFileChange(e, setInvoice);
                          setSelectedTransporterGstPan([...e.target.files]);
                        }}
                        className="mt-5"
                        disabled={isPending || uploading}
                        multiple
                      />
                      {selectedTransportGstPan.length > 0 && (
                        <div className="mt-2 p-2">
                          <p>Selected files:</p>
                          <ul className="list-decimal">
                            {selectedTransportGstPan.map((file, index) => (
                              <li key={index} className="font-bold text-sm">
                                {file.name}
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>

                    {formik.errors.transporter_gst_pan ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.errors.transporter_gst_pan}
                      </div>
                    ) : null}
                  </div>
                  <div className="">
                    <div className="border-2 rounded p-2 bg-gray-300">
                      <div className="text-xl mb-3">
                        <span> RC</span>
                      </div>
                      {docState.rc_oms.length === 0 ? (
                        <div>
                          <div>
                            <i
                              class="fa fa-file-pdf-o fs-1 text-secondary"
                              aria-hidden="true"
                            ></i>
                          </div>
                          <span className="p-1 bg-red-200 rounded mb-2">
                            <span style={{ color: "#fc3503" }}>
                              Not Uploaded
                            </span>
                          </span>
                        </div>
                      ) : (
                        docState.rc_oms.map((each, index) => (
                          <div key={index} className="border-2">
                            <div className="cursor-pointer flex justify-between">
                              <div></div>
                              <div onClick={() => handleDeleteRc(index)}>
                                <DeleteIcon />
                              </div>
                            </div>
                            {(each?.toLowerCase().endsWith(".jpg") ||
                              each?.toLowerCase().endsWith(".png") ||
                              each?.toLowerCase().endsWith(".jpeg")) && (
                              <div>
                                <ImageIcon style={{ fontSize: "60px" }} />
                              </div>
                            )}
                            {each?.toLowerCase().endsWith(".pdf") && (
                              <div>
                                <FileCopyIcon style={{ fontSize: "60px" }} />
                              </div>
                            )}
                            <div className="p-2">
                              <div>
                                <button
                                  className="bg-blue-500 text-white rounded p-2 mr-2"
                                  onClick={() => handleModalOpen(each)}
                                  type="button"
                                >
                                  View
                                </button>
                                <button
                                  className="bg-blue-500 text-white rounded p-2"
                                  type="button"
                                >
                                  <a
                                    style={{
                                      textDecoration: "none",
                                      color: "inherit",
                                    }}
                                    href={each}
                                  >
                                    Download
                                  </a>
                                </button>
                              </div>
                            </div>
                          </div>
                        ))
                      )}
                      <input
                        id="file"
                        type="file"
                        name="rc"
                        onChange={(e) => {
                          onFileChange(e, setInvoice);
                          setRcSelectedFile([...e.target.files]);
                        }}
                        className="mt-5"
                        disabled={isPending || uploading}
                        multiple
                      />
                      {rcSelectedFile.length > 0 && (
                        <div className="mt-2 p-2">
                          <p>Selected files:</p>
                          <ul className="list-decimal">
                            {rcSelectedFile.map((file, index) => (
                              <li key={index} className="font-bold text-sm">
                                {file.name}
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="">
                    <div className="border-2 rounded p-2 bg-gray-300">
                      <div className="text-xl mb-3">
                        <span>Truck Loading Image</span>
                      </div>

                      {docState.truck_loading_image_oms.length === 0 ? (
                        <div>
                          <div>
                            <i
                              class="fa fa-file-pdf-o fs-1 text-secondary"
                              aria-hidden="true"
                            ></i>
                          </div>
                          <span className="p-1 bg-red-200 rounded mb-2">
                            <span style={{ color: "#fc3503" }}>
                              Not Uploaded
                            </span>
                          </span>
                        </div>
                      ) : (
                        docState.truck_loading_image_oms.map((each, index) => (
                          <div key={index} className="border-2">
                            <div className="cursor-pointer flex justify-between">
                              <div></div>
                              <div
                                onClick={() => handleDeleteTruckLoading(index)}
                              >
                                <DeleteIcon />
                              </div>
                            </div>
                            {(each?.toLowerCase().endsWith(".jpg") ||
                              each?.toLowerCase().endsWith(".png") ||
                              each?.toLowerCase().endsWith(".jpeg")) && (
                              <div>
                                <ImageIcon style={{ fontSize: "60px" }} />
                              </div>
                            )}
                            {each?.toLowerCase().endsWith(".pdf") && (
                              <div>
                                <FileCopyIcon style={{ fontSize: "60px" }} />
                              </div>
                            )}
                            <div className="p-2">
                              <div>
                                <button
                                  className="bg-blue-500 text-white rounded p-2 mr-2"
                                  onClick={() => handleModalOpen(each)}
                                  type="button"
                                >
                                  View
                                </button>
                                <button
                                  className="bg-blue-500 text-white rounded p-2"
                                  type="button"
                                >
                                  <a
                                    style={{
                                      textDecoration: "none",
                                      color: "inherit",
                                    }}
                                    href={each}
                                  >
                                    Download
                                  </a>
                                </button>
                              </div>
                            </div>
                          </div>
                        ))
                      )}

                      <input
                        id="file"
                        type="file"
                        name="truck_loading_image"
                        className="mt-5"
                        onChange={(e) => {
                          onFileChange(e, setInvoice);
                          setSelectedTruckLoadingImage([...e.target.files]);
                        }}
                        disabled={isPending || uploading}
                        multiple
                      />
                      {selectedTruckLoadingImage.length > 0 && (
                        <div className="mt-2 p-2">
                          <p>Selected files:</p>
                          <ul className="list-decimal">
                            {selectedTruckLoadingImage.map((file, index) => (
                              <li key={index} className="font-bold text-sm">
                                {file.name}
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>

                    {formik.errors.truck_loading_image ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.errors.truck_loading_image}
                      </div>
                    ) : null}
                  </div>
                  <div className="">
                    <div className="border-2 rounded p-2 bg-gray-300">
                      <div className="text-xl mb-3">
                        <span>Driver Photo</span>
                      </div>
                      {docState.driver_photo_oms.length === 0 ? (
                        <div>
                          <div>
                            <i
                              class="fa fa-file-pdf-o fs-1 text-secondary"
                              aria-hidden="true"
                            ></i>
                          </div>
                          <span className="p-1 bg-red-200 rounded mb-2">
                            <span style={{ color: "#fc3503" }}>
                              Not Uploaded
                            </span>
                          </span>
                        </div>
                      ) : (
                        docState.driver_photo_oms.map((each, index) => (
                          <div key={index} className="border-2">
                            <div className="cursor-pointer flex justify-between">
                              <div></div>
                              <div
                                onClick={() => handleDeleteDriverPhoto(index)}
                              >
                                <DeleteIcon />
                              </div>
                            </div>
                            {(each?.toLowerCase().endsWith(".jpg") ||
                              each?.toLowerCase().endsWith(".png") ||
                              each?.toLowerCase().endsWith(".jpeg")) && (
                              <div>
                                <ImageIcon style={{ fontSize: "60px" }} />
                              </div>
                            )}
                            {each?.toLowerCase().endsWith(".pdf") && (
                              <div>
                                <FileCopyIcon style={{ fontSize: "60px" }} />
                              </div>
                            )}
                            <div className="p-2">
                              <div>
                                <button
                                  className="bg-blue-500 text-white rounded p-2 mr-2"
                                  onClick={() => handleModalOpen(each)}
                                  type="button"
                                >
                                  View
                                </button>
                                <button
                                  className="bg-blue-500 text-white rounded p-2"
                                  type="button"
                                >
                                  <a
                                    style={{
                                      textDecoration: "none",
                                      color: "inherit",
                                    }}
                                    href={each}
                                  >
                                    Download
                                  </a>
                                </button>
                              </div>
                            </div>
                          </div>
                        ))
                      )}

                      <input
                        id="file"
                        type="file"
                        name="driver_photo"
                        onChange={(e) => {
                          onFileChange(e, setInvoice);
                          setSelectedDriverPhoto([...e.target.files]);
                        }}
                        className="mt-5"
                        disabled={isPending || uploading}
                        multiple
                      />
                      {selectedDriverPhoto.length > 0 && (
                        <div className="mt-2 p-2">
                          <p>Selected files:</p>
                          <ul className="list-decimal">
                            {selectedDriverPhoto.map((file, index) => (
                              <li key={index} className="font-bold text-sm">
                                {file.name}
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>

                    {formik.errors.driver_photo ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.errors.driver_photo}
                      </div>
                    ) : null}
                  </div>
                  <div className="">
                    <div className="border-2 rounded p-2 bg-gray-300">
                      <div className="text-xl mb-3">
                        <span> Driver License</span>
                      </div>

                      {docState.driver_license_oms.length === 0 ? (
                        <div>
                          <div>
                            <i
                              class="fa fa-file-pdf-o fs-1 text-secondary"
                              aria-hidden="true"
                            ></i>
                          </div>
                          <span className="p-1 bg-red-200 rounded mb-2">
                            <span style={{ color: "#fc3503" }}>
                              Not Uploaded
                            </span>
                          </span>
                        </div>
                      ) : (
                        docState.driver_license_oms.map((each, index) => (
                          <div key={index} className="border-2">
                            <div className="cursor-pointer flex justify-between">
                              <div></div>
                              <div
                                onClick={() => handleDeleteDriverLicense(index)}
                              >
                                <DeleteIcon />
                              </div>
                            </div>
                            {(each?.toLowerCase().endsWith(".jpg") ||
                              each?.toLowerCase().endsWith(".png") ||
                              each?.toLowerCase().endsWith(".jpeg")) && (
                              <div>
                                <ImageIcon style={{ fontSize: "60px" }} />
                              </div>
                            )}
                            {each?.toLowerCase().endsWith(".pdf") && (
                              <div>
                                <FileCopyIcon style={{ fontSize: "60px" }} />
                              </div>
                            )}
                            <div className="p-2">
                              <div>
                                <button
                                  className="bg-blue-500 text-white rounded p-2 mr-2"
                                  onClick={() => handleModalOpen(each)}
                                  type="button"
                                >
                                  View
                                </button>
                                <button
                                  className="bg-blue-500 text-white rounded p-2"
                                  type="button"
                                >
                                  <a
                                    style={{
                                      textDecoration: "none",
                                      color: "inherit",
                                    }}
                                    href={each}
                                  >
                                    Download
                                  </a>
                                </button>
                              </div>
                            </div>
                          </div>
                        ))
                      )}

                      <input
                        id="file"
                        type="file"
                        name="driver_license"
                        onChange={(e) => {
                          onFileChange(e, setInvoice);
                          setSelectedDriverLicense([...e.target.files]);
                        }}
                        className="mt-5"
                        disabled={isPending || uploading}
                        multiple
                      />

                      {selectedDriverLicense.length > 0 && (
                        <div className="mt-2 p-2">
                          <p>Selected files:</p>
                          <ul className="list-decimal">
                            {selectedDriverLicense.map((file, index) => (
                              <li key={index} className="font-bold text-sm">
                                {file.name}
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>

                    {formik.errors.driver_license ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.errors.driver_license}
                      </div>
                    ) : null}
                  </div>
                  <div className="">
                    <div className="border-2 rounded p-2 bg-gray-300">
                      <div className="text-xl mb-3">
                        <span>TDS Declaration</span>
                      </div>

                      {docState.tds_declaration_oms.length === 0 ? (
                        <div>
                          <div>
                            <i
                              class="fa fa-file-pdf-o fs-1 text-secondary"
                              aria-hidden="true"
                            ></i>
                          </div>
                          <span className="p-1 bg-red-200 rounded mb-2">
                            <span style={{ color: "#fc3503" }}>
                              Not Uploaded
                            </span>
                          </span>
                        </div>
                      ) : (
                        docState.tds_declaration_oms.map((each, index) => (
                          <div key={index} className="border-2">
                            <div className="cursor-pointer flex justify-between">
                              <div></div>
                              <div
                                onClick={() =>
                                  handleDeleteTdsDeclaration(index)
                                }
                              >
                                <DeleteIcon />
                              </div>
                            </div>
                            {(each?.toLowerCase().endsWith(".jpg") ||
                              each?.toLowerCase().endsWith(".png") ||
                              each?.toLowerCase().endsWith(".jpeg")) && (
                              <div>
                                <ImageIcon style={{ fontSize: "60px" }} />
                              </div>
                            )}
                            {each?.toLowerCase().endsWith(".pdf") && (
                              <div>
                                <FileCopyIcon style={{ fontSize: "60px" }} />
                              </div>
                            )}
                            <div className="p-2">
                              <div>
                                <button
                                  className="bg-blue-500 text-white rounded p-2 mr-2"
                                  onClick={() => handleModalOpen(each)}
                                  type="button"
                                >
                                  View
                                </button>
                                <button
                                  className="bg-blue-500 text-white rounded p-2"
                                  type="button"
                                >
                                  <a
                                    style={{
                                      textDecoration: "none",
                                      color: "inherit",
                                    }}
                                    href={each}
                                  >
                                    Download
                                  </a>
                                </button>
                              </div>
                            </div>
                          </div>
                        ))
                      )}
                      <input
                        id="file"
                        type="file"
                        name="tds_declaration"
                        onChange={(e) => {
                          onFileChange(e, setInvoice);
                          setSelectedTdsDeclaration([...e.target.files]);
                        }}
                        className="mt-5"
                        disabled={isPending || uploading}
                        multiple
                      />
                      {selectedTdsDeclaration.length > 0 && (
                        <div className="mt-2 p-2">
                          <p>Selected files:</p>
                          <ul className="list-decimal">
                            {selectedTdsDeclaration.map((file, index) => (
                              <li key={index} className="font-bold text-sm">
                                {file.name}
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>

                    {formik.errors.tds_declaration ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.errors.tds_declaration}
                      </div>
                    ) : null}
                  </div>
                  <div className="">
                    <div className="border-2 rounded p-2 bg-gray-300">
                      <div className="text-xl mb-3">
                        <span>Revised Bilti</span>
                      </div>
                      {docState.revised_bilti_oms.length === 0 ? (
                        <div>
                          <div>
                            <i
                              class="fa fa-file-pdf-o fs-1 text-secondary"
                              aria-hidden="true"
                            ></i>
                          </div>
                          <span className="p-1 bg-red-200 rounded mb-2">
                            <span style={{ color: "#fc3503" }}>
                              Not Uploaded
                            </span>
                          </span>
                        </div>
                      ) : (
                        docState.revised_bilti_oms.map((each, index) => (
                          <div key={index} className="border-2">
                            <div className="cursor-pointer flex justify-between">
                              <div></div>
                              <div
                                onClick={() => handleDeleteRevisedBilti(index)}
                              >
                                <DeleteIcon />
                              </div>
                            </div>
                            {(each?.toLowerCase().endsWith(".jpg") ||
                              each?.toLowerCase().endsWith(".png") ||
                              each?.toLowerCase().endsWith(".jpeg")) && (
                              <div>
                                <ImageIcon style={{ fontSize: "60px" }} />
                              </div>
                            )}
                            {each?.toLowerCase().endsWith(".pdf") && (
                              <div>
                                <FileCopyIcon style={{ fontSize: "60px" }} />
                              </div>
                            )}
                            <div className="p-2">
                              <div>
                                <button
                                  className="bg-blue-500 text-white rounded p-2 mr-2"
                                  onClick={() => handleModalOpen(each)}
                                  type="button"
                                >
                                  View
                                </button>
                                <button
                                  className="bg-blue-500 text-white rounded p-2"
                                  type="button"
                                >
                                  <a
                                    style={{
                                      textDecoration: "none",
                                      color: "inherit",
                                    }}
                                    href={each}
                                  >
                                    Download
                                  </a>
                                </button>
                              </div>
                            </div>
                          </div>
                        ))
                      )}

                      <input
                        id="file"
                        type="file"
                        name="revised_bilti"
                        onChange={(e) => {
                          onFileChange(e, setInvoice);
                          setSelectedRevisedBilti([...e.target.files]);
                        }}
                        className="mt-5"
                        disabled={isPending || uploading}
                        multiple
                      />
                      {selectedRevisedBilti.length > 0 && (
                        <div className="mt-2 p-2">
                          <p>Selected files:</p>
                          <ul className="list-decimal">
                            {selectedRevisedBilti.map((file, index) => (
                              <li key={index} className="font-bold text-sm">
                                {file.name}
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>

                    {formik.errors.revised_bilti ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.errors.revised_bilti}
                      </div>
                    ) : null}
                  </div>
                  <div className="">
                    <div className="border-2 rounded p-2 bg-gray-300">
                      <div className="text-xl mb-3">
                        <span>Kanta Parchi</span>
                      </div>

                      {docState.kanta_parchi_oms.length === 0 ? (
                        <div>
                          <div>
                            <i
                              class="fa fa-file-pdf-o fs-1 text-secondary"
                              aria-hidden="true"
                            ></i>
                          </div>
                          <span className="p-1 bg-red-200 rounded mb-2">
                            <span style={{ color: "#fc3503" }}>
                              Not Uploaded
                            </span>
                          </span>
                        </div>
                      ) : (
                        docState.kanta_parchi_oms.map((each, index) => (
                          <div key={index} className="border-2">
                            <div className="cursor-pointer flex justify-between">
                              <div></div>
                              <div
                                onClick={() => handleDeleteKantaParchi(index)}
                              >
                                <DeleteIcon />
                              </div>
                            </div>
                            {(each?.toLowerCase().endsWith(".jpg") ||
                              each?.toLowerCase().endsWith(".png") ||
                              each?.toLowerCase().endsWith(".jpeg")) && (
                              <div>
                                <ImageIcon style={{ fontSize: "60px" }} />
                              </div>
                            )}
                            {each?.toLowerCase().endsWith(".pdf") && (
                              <div>
                                <FileCopyIcon style={{ fontSize: "60px" }} />
                              </div>
                            )}
                            <div className="p-2">
                              <div>
                                <button
                                  className="bg-blue-500 text-white rounded p-2 mr-2"
                                  onClick={() => handleModalOpen(each)}
                                  type="button"
                                >
                                  View
                                </button>
                                <button
                                  className="bg-blue-500 text-white rounded p-2"
                                  type="button"
                                >
                                  <a
                                    style={{
                                      textDecoration: "none",
                                      color: "inherit",
                                    }}
                                    href={each}
                                  >
                                    Download
                                  </a>
                                </button>
                              </div>
                            </div>
                          </div>
                        ))
                      )}

                      <input
                        id="file"
                        type="file"
                        name="kanta_parchi"
                        onChange={(e) => {
                          onFileChange(e, setInvoice);
                          setSelectedKantaParchi([...e.target.files]);
                        }}
                        className="mt-5"
                        disabled={isPending || uploading}
                        multiple
                      />
                      {selectedKantaParchi.length > 0 && (
                        <div className="mt-2 p-2">
                          <p>Selected files:</p>
                          <ul className="list-decimal">
                            {selectedKantaParchi.map((file, index) => (
                              <li key={index} className="font-bold text-sm">
                                {file.name}
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>
                    {formik.errors.kanta_parchi ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.errors.kanta_parchi}
                      </div>
                    ) : null}
                  </div>

                  <div className="">
                    <div className="border-2 rounded p-2 bg-gray-300">
                      <div className="text-xl mb-3">
                        <span>Retailer Paid Cheque</span>
                      </div>
                      {docState.retailer_paid_cheque_oms.length === 0 ? (
                        <div>
                          <div>
                            <i
                              class="fa fa-file-pdf-o fs-1 text-secondary"
                              aria-hidden="true"
                            ></i>
                          </div>
                          <span className="p-1 bg-red-200 rounded mb-2">
                            <span style={{ color: "#fc3503" }}>
                              Not Uploaded
                            </span>
                          </span>
                        </div>
                      ) : (
                        docState.retailer_paid_cheque_oms.map((each, index) => (
                          <div key={index} className="border-2">
                            <div className="cursor-pointer flex justify-between">
                              <div></div>
                              <div
                                onClick={() =>
                                  handleDeleteRetailerCheque(index)
                                }
                              >
                                <DeleteIcon />
                              </div>
                            </div>
                            {(each?.toLowerCase().endsWith(".jpg") ||
                              each?.toLowerCase().endsWith(".png") ||
                              each?.toLowerCase().endsWith(".jpeg")) && (
                              <div>
                                <ImageIcon style={{ fontSize: "60px" }} />
                              </div>
                            )}
                            {each?.toLowerCase().endsWith(".pdf") && (
                              <div>
                                <FileCopyIcon style={{ fontSize: "60px" }} />
                              </div>
                            )}
                            <div className="p-2">
                              <div>
                                <button
                                  className="bg-blue-500 text-white rounded p-2 mr-2"
                                  onClick={() => handleModalOpen(each)}
                                  type="button"
                                >
                                  View
                                </button>
                                <button
                                  className="bg-blue-500 text-white rounded p-2"
                                  type="button"
                                >
                                  <a
                                    style={{
                                      textDecoration: "none",
                                      color: "inherit",
                                    }}
                                    href={each}
                                  >
                                    Download
                                  </a>
                                </button>
                              </div>
                            </div>
                          </div>
                        ))
                      )}

                      <div>
                        <input
                          id="file"
                          type="file"
                          name="retailer_paid_cheque"
                          onChange={(e) => {
                            onFileChange(e, setInvoice);
                            setSelectedRetalierPaidCheque([...e.target.files]);
                          }}
                          className="mt-5"
                          disabled={isPending || uploading}
                          multiple
                        />
                        {selectedRetailerPaidCheque.length > 0 && (
                          <div className="mt-2 p-2">
                            <p>Selected files:</p>
                            <ul className="list-decimal">
                              {selectedRetailerPaidCheque.map((file, index) => (
                                <li key={index} className="font-bold text-sm">
                                  {file.name}
                                </li>
                              ))}
                            </ul>
                          </div>
                        )}
                      </div>
                    </div>
                    {formik.errors.retailer_paid_cheque ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.errors.retailer_paid_cheque}
                      </div>
                    ) : null}
                  </div>
                  {/* <div className="">
                        <div className="border-2 rounded p-2 bg-gray-300">
                          <div className="text-xl mb-3">
                            <span>GRN Document</span>
                          </div>

                          {
                            docState.grn_document_oms.length === 0
                            ?
                            <span
                                className="p-1 bg-red-200 rounded"
                              >
                                <span style={{color: "#fc3503"}}>Not Uploaded</span>
                              </span>
                            :
                            docState.grn_document_oms.map((each, index) => (
                              <div key={index} className="border-2">
                                <div className="cursor-pointer flex justify-between">
                                  
                                  
                                  <div></div>
                                  <div onClick={() => handleDeleteGrnDocument(index)}>
                                    <DeleteIcon  />
                                  </div>
                                </div>
                            {
                            (each?.toLowerCase().endsWith(".jpg") 
                            || each?.toLowerCase().endsWith(".png") ||
                            each?.toLowerCase().endsWith(".jpeg"))
                               &&
                              <div >
                                <ImageIcon style={{fontSize: "60px"}} />
                              </div>
                            }
                            {
                              each?.toLowerCase().endsWith(".pdf") &&
                              <div >
                                <FileCopyIcon style={{fontSize: "60px"}} />
                              </div>
                            }
                            <div className="p-2">
                              <div>
                                <button className="bg-blue-500 text-white rounded p-2 mr-2"
                                  onClick={() => handleModalOpen(each)}
                                  type="button"
                                >
                                  View
                                </button>
                              <button
                                  className="bg-blue-500 text-white rounded p-2"
                                  type="button"
                                  >
                                  <a  
                                      style={{
                                        textDecoration: 'none', 
                                        color: 'inherit', 
                                        
                                        
                                      }}
                                      href={each}>Download</a>
                                  </button>

                              </div>  
                            </div>
                          </div>
                          ))
                            
                          }
                          
                          
                          <div>
                              <input 
                                id="file" 
                                type="file" 
                                name="grn_document"
                                className="mt-5"
                                onChange={(e) => {
                                  onFileChange(e, setInvoice);
                                  setSelectedGrnDocument([...e.target.files]);
                                }}
                                disabled={uploading}
                                multiple
                              />

                          {selectedGrnDocument.length > 0 && (
                            <div className="mt-2 p-2">
                              <p>Selected files:</p>
                              <ul className="list-decimal">
                                {selectedGrnDocument.map((file, index) => (
                                  <li key={index} className="font-bold text-sm">{file.name}</li>
                                ))}
                              </ul>
                            </div>
                          )}
                            
                          </div>
                          
                        </div>
                        {formik.errors.grn_document ? (
                          <div className="text-red-600 text-sm">
                            {formik.errors.grn_document}
                          </div>
                        ) : null}
                    </div> */}
                  <div className="">
                    <div className="border-2 rounded p-2 bg-gray-300">
                      <div className="text-xl mb-3">
                        <span>E-Way Bill</span>
                      </div>
                      {docState.eway_oms.length === 0 ? (
                        <div>
                          <div>
                            <i
                              class="fa fa-file-pdf-o fs-1 text-secondary"
                              aria-hidden="true"
                            ></i>
                          </div>
                          <span className="p-1 bg-red-200 rounded mb-2">
                            <span style={{ color: "#fc3503" }}>
                              Not Uploaded
                            </span>
                          </span>
                        </div>
                      ) : (
                        docState.eway_oms.map((each, index) => (
                          <div key={index} className="border-2">
                            <div className="cursor-pointer flex justify-between">
                              <div></div>
                              <div onClick={() => handleDeleteEwayBill(index)}>
                                <DeleteIcon />
                              </div>
                            </div>
                            {(each?.toLowerCase().endsWith(".jpg") ||
                              each?.toLowerCase().endsWith(".png") ||
                              each?.toLowerCase().endsWith(".jpeg")) && (
                              <div>
                                <ImageIcon style={{ fontSize: "60px" }} />
                              </div>
                            )}
                            {each?.toLowerCase().endsWith(".pdf") && (
                              <div>
                                <FileCopyIcon style={{ fontSize: "60px" }} />
                              </div>
                            )}
                            <div className="p-2">
                              <div>
                                <button
                                  className="bg-blue-500 text-white rounded p-2 mr-2"
                                  onClick={() => handleModalOpen(each)}
                                  type="button"
                                >
                                  View
                                </button>
                                <button
                                  className="bg-blue-500 text-white rounded p-2"
                                  type="button"
                                >
                                  <a
                                    style={{
                                      textDecoration: "none",
                                      color: "inherit",
                                    }}
                                    href={each}
                                  >
                                    Download
                                  </a>
                                </button>
                              </div>
                            </div>
                          </div>
                        ))
                      )}

                      <div>
                        <input
                          id="file"
                          type="file"
                          name="eway"
                          className="mt-5"
                          onChange={(e) => {
                            onFileChange(e, setInvoice);
                            setSelectedEway([...e.target.files]);
                          }}
                          disabled={isPending || uploading}
                          multiple
                        />

                        {selectedEway.length > 0 && (
                          <div className="mt-2 p-2">
                            <p>Selected files:</p>
                            <ul className="list-decimal">
                              {selectedEway.map((file, index) => (
                                <li key={index} className="font-bold text-sm">
                                  {file.name}
                                </li>
                              ))}
                            </ul>
                          </div>
                        )}
                      </div>
                    </div>
                    {formik.errors.eway ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.errors.eway}
                      </div>
                    ) : null}
                  </div>

                  {/* Insurence Doc  truck_insurance_docs */}

                  <div className="">
                    <div className="border-2 rounded p-2 bg-gray-300">
                      <div className="text-xl mb-3">
                        <span>Truck Insurance</span>
                      </div>
                      {docState.truck_insurance_docs?.length === 0 ? (
                        <div>
                          <div>
                            <i
                              class="fa fa-file-pdf-o fs-1 text-secondary"
                              aria-hidden="true"
                            ></i>
                          </div>
                          <span className="p-1 bg-red-200 rounded mb-2">
                            <span style={{ color: "#fc3503" }}>
                              Not Uploaded
                            </span>
                          </span>
                        </div>
                      ) : (
                        docState.truck_insurance_docs.map((each, index) => (
                          <div key={index} className="border-2">
                            <div className="cursor-pointer flex justify-between">
                              <div></div>
                              <div
                                onClick={() =>
                                  handleDeleteTrackInsurence(index)
                                }
                              >
                                <DeleteIcon />
                              </div>
                            </div>
                            {(each?.toLowerCase().endsWith(".jpg") ||
                              each?.toLowerCase().endsWith(".png") ||
                              each?.toLowerCase().endsWith(".jpeg")) && (
                              <div>
                                <ImageIcon style={{ fontSize: "60px" }} />
                              </div>
                            )}
                            {each?.toLowerCase().endsWith(".pdf") && (
                              <div>
                                <FileCopyIcon style={{ fontSize: "60px" }} />
                              </div>
                            )}
                            <div className="p-2">
                              <div>
                                <button
                                  className="bg-blue-500 text-white rounded p-2 mr-2"
                                  onClick={() => handleModalOpen(each)}
                                  type="button"
                                >
                                  View
                                </button>
                                <button
                                  className="bg-blue-500 text-white rounded p-2"
                                  type="button"
                                >
                                  <a
                                    style={{
                                      textDecoration: "none",
                                      color: "inherit",
                                    }}
                                    href={each}
                                  >
                                    Download
                                  </a>
                                </button>
                              </div>
                            </div>
                          </div>
                        ))
                      )}

                      <div>
                        <input
                          id="file"
                          type="file"
                          name="truck_insurance_docs"
                          className="mt-5"
                          onChange={(e) => {
                            onFileChange(e, setInvoice);
                            setSelectedInsurenceDoc([...e.target.files]);
                          }}
                          disabled={isPending || uploading}
                          multiple
                        />

                        {selectedInsurenceDoc.length > 0 && (
                          <div className="mt-2 p-2">
                            <p>Selected files:</p>
                            <ul className="list-decimal">
                              {selectedInsurenceDoc.map((file, index) => (
                                <li key={index} className="font-bold text-sm">
                                  {file.name}
                                </li>
                              ))}
                            </ul>
                          </div>
                        )}
                      </div>
                    </div>
                    {formik.errors.eway ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.errors.truck_insurance_docs}
                      </div>
                    ) : null}
                  </div>
                </div>

                <div>
                  {uploading ? (
                    <div>
                      <ClipLoader />
                    </div>
                  ) : (
                    <div className="flex justify-end mt-2">
                      {/*<Button 
                            color="error"
                            onClick={(e) => formik.resetForm()}
                          >
                            CLEAR
                          </Button>*/}
                      <Button
                        variant="contained"
                        size="small"
                        type="submit"
                        sx={{ backgroundColor: "#0D9223" }}
                        disabled={isPending}
                      >
                        SAVE
                      </Button>
                    </div>
                  )}
                </div>
              </form>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default TransportDetailSupplierForm;
